import React from 'react';
import './EnvBanner.css';

/**
 * Sessão 24 — Fase 1 ambientes separados.
 *
 * Banner visual no topo do app pra evitar o erro clássico de "achei que
 * tava em produção e era staging" (ou vice-versa). Renderiza barra
 * colorida quando REACT_APP_ENV != 'production'.
 *
 * Convenções:
 *   - production → não renderiza nada (return null)
 *   - staging    → barra vermelha forte: "AMBIENTE DE TESTE — dados não-reais"
 *   - development → barra amarela discreta: "DEV LOCAL"
 *   - outro valor → barra cinza com o valor exato (defensivo)
 */
function EnvBanner() {
  const env = (process.env.REACT_APP_ENV || 'production').toLowerCase();

  if (env === 'production') return null;

  if (env === 'staging') {
    return (
      <div className="env-banner env-banner-staging" role="status" aria-live="polite">
        <strong><span className="material-symbols-outlined" style={{ fontSize: '15px', verticalAlign: 'text-bottom' }}>warning</span> AMBIENTE DE TESTE (STAGING)</strong>
        <span> — dados não-reais. Não use pra ocorrências ou NCs de cliente.</span>
      </div>
    );
  }

  if (env === 'development') {
    return (
      <div className="env-banner env-banner-dev" role="status" aria-live="polite">
        <strong>DEV LOCAL</strong>
        <span> — backend em localhost:8000</span>
      </div>
    );
  }

  // Defensivo: qualquer outro valor (test, etc) — barra cinza com o nome
  return (
    <div className="env-banner env-banner-unknown" role="status" aria-live="polite">
      <strong>AMBIENTE: {env.toUpperCase()}</strong>
    </div>
  );
}

export default EnvBanner;
